import * as React from 'react'
import Select from 'react-select'
import { QuickBooksModels } from '@getgreenline/quickbooks'

interface IProps {
  location: QuickBooksModels.IQuickBooksLocationToSyncResponse
  options: Array<{ value: string; label: string }>
  onSelect: (locationId: number, accountId: string | null) => void
}

export const LocationDepartmentSelector: React.FC<IProps> = ({
  location,
  options,
  onSelect,
}: IProps) => (
  <tr>
    <td className='mr-2' style={{ width: 150 }}>
      {location.locationName}
    </td>
    <td>
      <Select
        value={location.classId}
        clearable={true}
        placeholder={'Select Quickbooks class'}
        options={options}
        onChange={(option: { label: string; value: string }) => {
          const newAccountId = option ? option.value : null
          onSelect(location.locationId, newAccountId)
        }}
      />
    </td>
  </tr>
)
